import { useAuthenticationApi } from '../../infrastructure/api/useAuthApi'

/**
 * Hook to use authentication API functions
 * @returns Object with authentication API functions
 */
export const useAuthenticationUseCase = () => {
  const { getCurrentUser } = useAuthenticationApi()

  return {
    getCurrentUser: async () => {
      return getCurrentUser()
    },
  }
}
